export const CHANGE_SETTING = 'CHANGE_SETTING';

export function changeSetting(key, value) {
  return {
    type: CHANGE_SETTING,
    key,
    value,
  };
}

export const CHANGE_SETTINGS = 'CHANGE_SETTINGS';

export function changeSettings(mapping) {
  return {
    type: CHANGE_SETTINGS,
    mapping,
  };
}



// WEBPACK FOOTER //
// ./src/common/actions/settings.js